import _ from "lodash";

const body = document.getElementsByTagName('body')[0];

const store = {
	namespaced: true,
	getters: {
		isShowBackdrop: (state) => state.openFans.length > 0,
	},
	state: {
		openFans: [],
		fanLevelClasses: {},
	},
	mutations: {
		addOpenFan: (state, fanKey) =>
		{
			state.openFans.push(fanKey);
			state.fanLevelClasses = getFanLevelClasses(state.openFans);

			body.classList.add('prevent-scrolling');
		},
		removeOpenFan: (state, fanKey) =>
		{
			state.openFans = _.filter(state.openFans, key => key !== fanKey);

			state.fanLevelClasses = getFanLevelClasses(state.openFans);

			if (state.openFans.length === 0)
			{
				body.classList.remove('prevent-scrolling');
			}
		},
	},
};

function getFanLevelClasses (openFans)
{
	let classes = {};

	const openFansLocal = _.reverse(
		_.cloneDeep(openFans)
	);

	_.forEach(openFansLocal, (key, i) =>
	{
		classes[key] = 'slide-in-level-' + i;
	});

	return classes;
}

export default store;
